import { render, staticRenderFns } from "./documentViewPermission.vue?vue&type=template&id=b7064dd8&scoped=true"
import script from "./documentViewPermission.vue?vue&type=script&lang=js"
export * from "./documentViewPermission.vue?vue&type=script&lang=js"
import style0 from "./documentViewPermission.vue?vue&type=style&index=0&id=b7064dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7064dd8",
  null
  
)

export default component.exports